import { useDemoMode } from '../contexts/DemoModeContext';

export default function Settings() {
  const { isDemoMode, setIsDemoMode } = useDemoMode();

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white mb-2">Settings</h2>
        <p className="text-muted-foreground text-sm">
          Configure display options and application settings.
        </p>
      </div>

      {/* Display Options Section */}
      <section className="bg-card rounded-lg shadow-sm p-6 border border-border">
        <h3 className="text-lg font-semibold text-white mb-4">Display Options</h3>
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            id="demoMode"
            checked={isDemoMode}
            onChange={(e) => setIsDemoMode(e.target.checked)}
            className="w-5 h-5 rounded border-border bg-secondary text-success focus:ring-2 focus:ring-success focus:ring-offset-2 focus:ring-offset-card cursor-pointer"
          />
          <label htmlFor="demoMode" className="text-foreground cursor-pointer">
            <span className="font-medium">Demo mode</span>
            <p className="text-sm text-muted-foreground mt-1">
              When enabled, sensitive information will be redacted for client demonstrations. 
              Real labels will be replaced with generic labels.
            </p>
          </label>
        </div>
      </section>
    </div>
  );
}
